// import React, { useState, useEffect } from 'react';
// import toast from 'react-hot-toast';

// const BASE_URL = process.env.REACT_APP_API_URL || '';

// export default function CardExportModal({
//   profiles,
//   jobOptions,
//   classOptions,
//   username,
//   onClose,
//   api
// }) {
//   // ---------- existing state ----------
//   const [templates, setTemplates] = useState([]);
//   const [selectedTmpl, setSelectedTmpl] = useState(''); // will be used as front template
//   const [filterJob, setFilterJob] = useState('');
//   const [filterClass, setFilterClass] = useState('');
//   const [selectedIds, setSelectedIds] = useState(new Set());
//   const [filteredProfs, setFilteredProfs] = useState(profiles || []);
//   const [exporting, setExporting] = useState(false);

//   // ---------- new export options ----------
//   const [format, setFormat] = useState('pdf'); // 'pdf' | 'jpeg'
//   const [pattern, setPattern] = useState('front-only'); // 'front-only' | 'both-same-side' | 'duplex'
//   const [paperSize, setPaperSize] = useState('A4'); // key
//   const [customWidth, setCustomWidth] = useState(210); // mm
//   const [customHeight, setCustomHeight] = useState(297); // mm
//   const [gapRow, setGapRow] = useState(2); // mm
//   const [gapCol, setGapCol] = useState(2); // mm
//   const [rotationBack, setRotationBack] = useState(180); // degrees

//   // separate template IDs for front and back
//   const [frontTemplateId, setFrontTemplateId] = useState('');
//   const [backTemplateId, setBackTemplateId] = useState('');

//   // predefined paper sizes in mm (width x height)
//   const paperSizes = {
//     A4: { w: 210, h: 297 },
//     A5: { w: 148, h: 210 },
//     '4x6': { w: 101.6, h: 152.4 },   // 4" x 6"
//     '8x12': { w: 203.2, h: 304.8 },  // 8" x 12"
//     '12x18': { w: 304.8, h: 457.2 }, // 12" x 18"
//     '13x19': { w: 330.2, h: 482.6 }, // 13" x 19"
//     custom: { w: customWidth, h: customHeight },
//   };

//   // ---------- fetch templates ----------
//   useEffect(() => {
//     api.get('/templates')
//       .then(r => {
//         setTemplates(r.data);
//         if (r.data.length) {
//           // set first front and back templates as default
//           const front = r.data.find(t => t.cardSide === 'front');
//           const back = r.data.find(t => t.cardSide === 'back');
//           if (front) setFrontTemplateId(front._id);
//           if (back) setBackTemplateId(back._id);
//           // also set selectedTmpl for preview (legacy)
//           setSelectedTmpl(front?._id || r.data[0]._id);
//         }
//       })
//       .catch(() => {});
//   }, [api]);

//   // ---------- filter profiles ----------
//   useEffect(() => {
//     let fp = profiles || [];
//     if (filterJob) fp = fp.filter(p => String(p.jobNo) === String(filterJob));
//     if (filterClass) fp = fp.filter(p => p.class === filterClass);
//     setFilteredProfs(fp);
//     setSelectedIds(new Set(fp.map(p => p._id)));
//   }, [profiles, filterJob, filterClass]);

//   // ---------- toggle selection ----------
//   const toggleSelect = id => {
//     setSelectedIds(prev => {
//       const n = new Set(prev);
//       n.has(id) ? n.delete(id) : n.add(id);
//       return n;
//     });
//   };

//   // ---------- compute paper dimensions ----------
//   const getPaperDimensions = () => {
//     if (paperSize === 'custom') {
//       return { w: customWidth, h: customHeight };
//     }
//     const size = paperSizes[paperSize];
//     return size ? { w: size.w, h: size.h } : { w: 210, h: 297 };
//   };

//   // ---------- export handler ----------
//   const handleExport = async () => {
//     if (!frontTemplateId) {
//       toast.error('Please select a front template');
//       return;
//     }
//     if ((pattern === 'both-same-side' || pattern === 'duplex') && !backTemplateId) {
//       toast.error('Please select a back template');
//       return;
//     }
//     if (!selectedIds.size) {
//       toast.error('Select at least one profile');
//       return;
//     }

//     setExporting(true);
//     try {
//       const { w: paperWidth, h: paperHeight } = getPaperDimensions();

//       const payload = {
//         frontTemplateId,
//         backTemplateId: (pattern !== 'front-only') ? backTemplateId : undefined,
//         profileIds: [...selectedIds],
//         paperWidth,
//         paperHeight,
//         pattern,
//         gapRow,
//         gapCol,
//         rotationBack: (pattern === 'both-same-side') ? rotationBack : 0,
//         format,
//         dpi: 300,
//       };

//       const resp = await api.post('/templates/render/export', payload, {
//         responseType: 'blob',
//         headers: {
//           'Accept': format === 'jpeg' ? 'application/zip' : 'application/pdf',
//         },
//       });

//       const contentType = resp.headers?.['content-type'] || '';
//       const disposition = resp.headers?.['content-disposition'] || '';
//       const filename = disposition.match(/filename="?(.+)"?/)?.[1] || `cards_${Date.now()}.${format === 'jpeg' ? 'zip' : 'pdf'}`;

//       // handle fallback HTML (only for PDF)
//       if (format === 'pdf' && (contentType.includes('text/html') || resp.headers?.['x-pdf-fallback'] === 'true')) {
//         const blob = new Blob([resp.data], { type: 'text/html' });
//         const url = URL.createObjectURL(blob);
//         const win = window.open(url, '_blank');
//         if (win) win.onload = () => win.print();
//         URL.revokeObjectURL(url);
//         toast('📄 Opened in browser — Ctrl+P to save as PDF', { icon: 'ℹ️', duration: 6000 });
//       } else {
//         // download blob
//         const blob = new Blob([resp.data], {
//           type: contentType || (format === 'jpeg' ? 'application/zip' : 'application/pdf'),
//         });
//         const url = URL.createObjectURL(blob);
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = filename;
//         document.body.appendChild(a);
//         a.click();
//         a.remove();
//         URL.revokeObjectURL(url);
//         toast.success(`Exported ${selectedIds.size} cards as ${format.toUpperCase()}`);
//       }
//     } catch (e) {
//       let msg = 'Export failed';
//       if (e.response?.data instanceof Blob) {
//         try {
//           const text = await e.response.data.text();
//           msg = JSON.parse(text).message || msg;
//         } catch {}
//       } else if (e.message) msg = e.message;
//       toast.error(msg);
//     } finally {
//       setExporting(false);
//     }
//   };

//   // ---------- filter templates by side ----------
//   const frontTemplates = templates.filter(t => t.cardSide === 'front');
//   const backTemplates = templates.filter(t => t.cardSide === 'back');

//   // ---------- render ----------
//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div
//         className="modal"
//         style={{ maxWidth: 960, maxHeight: '92vh', overflowY: 'auto' }}
//         onClick={e => e.stopPropagation()}
//       >
//         <div className="modal-header">
//           <h2>🖨️ Export ID Cards</h2>
//           <button className="modal-close" onClick={onClose}>✕</button>
//         </div>
//         <div className="modal-body">

//           {/* --- Template Selection --- */}
//           <div style={{ marginBottom: 16, display: 'flex', gap: 20, flexWrap: 'wrap' }}>
//             <div>
//               <label style={{ fontWeight: 600, fontSize: '.85rem', display: 'block', marginBottom: 4 }}>
//                 Front Template
//               </label>
//               <select
//                 className="search-input"
//                 value={frontTemplateId}
//                 onChange={e => setFrontTemplateId(e.target.value)}
//                 style={{ minWidth: 150 }}
//               >
//                 {frontTemplates.length === 0 && <option value="">No front templates</option>}
//                 {frontTemplates.map(t => (
//                   <option key={t._id} value={t._id}>{t.name}</option>
//                 ))}
//               </select>
//             </div>
//             {(pattern === 'both-same-side' || pattern === 'duplex') && (
//               <div>
//                 <label style={{ fontWeight: 600, fontSize: '.85rem', display: 'block', marginBottom: 4 }}>
//                   Back Template
//                 </label>
//                 <select
//                   className="search-input"
//                   value={backTemplateId}
//                   onChange={e => setBackTemplateId(e.target.value)}
//                   style={{ minWidth: 150 }}
//                 >
//                   {backTemplates.length === 0 && <option value="">No back templates</option>}
//                   {backTemplates.map(t => (
//                     <option key={t._id} value={t._id}>{t.name}</option>
//                   ))}
//                 </select>
//               </div>
//             )}
//           </div>

//           {/* --- Export Options --- */}
//           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>

//             {/* Paper Size */}
//             <div>
//               <label style={{ fontWeight: 600, fontSize: '.85rem' }}>Paper Size</label>
//               <select
//                 className="search-input"
//                 value={paperSize}
//                 onChange={e => setPaperSize(e.target.value)}
//                 style={{ width: '100%' }}
//               >
//                 <option value="A4">A4 (210×297 mm)</option>
//                 <option value="A5">A5 (148×210 mm)</option>
//                 <option value="4x6">4×6" (101.6×152.4 mm)</option>
//                 <option value="8x12">8×12" (203.2×304.8 mm)</option>
//                 <option value="12x18">12×18" (304.8×457.2 mm)</option>
//                 <option value="13x19">13×19" (330.2×482.6 mm)</option>
//                 <option value="custom">Custom</option>
//               </select>
//               {paperSize === 'custom' && (
//                 <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
//                   <input
//                     type="number"
//                     className="search-input"
//                     value={customWidth}
//                     onChange={e => setCustomWidth(Number(e.target.value))}
//                     placeholder="Width (mm)"
//                     style={{ width: '50%' }}
//                   />
//                   <input
//                     type="number"
//                     className="search-input"
//                     value={customHeight}
//                     onChange={e => setCustomHeight(Number(e.target.value))}
//                     placeholder="Height (mm)"
//                     style={{ width: '50%' }}
//                   />
//                 </div>
//               )}
//             </div>

//             {/* Format */}
//             <div>
//               <label style={{ fontWeight: 600, fontSize: '.85rem' }}>Export Format</label>
//               <div style={{ display: 'flex', gap: 16, marginTop: 4 }}>
//                 <label>
//                   <input
//                     type="radio"
//                     value="pdf"
//                     checked={format === 'pdf'}
//                     onChange={() => setFormat('pdf')}
//                   /> PDF
//                 </label>
//                 <label>
//                   <input
//                     type="radio"
//                     value="jpeg"
//                     checked={format === 'jpeg'}
//                     onChange={() => setFormat('jpeg')}
//                   /> JPEG (300 DPI)
//                 </label>
//               </div>
//             </div>

//             {/* Layout Pattern */}
//             <div>
//               <label style={{ fontWeight: 600, fontSize: '.85rem' }}>Card Layout</label>
//               <select
//                 className="search-input"
//                 value={pattern}
//                 onChange={e => setPattern(e.target.value)}
//                 style={{ width: '100%' }}
//               >
//                 <option value="front-only">Front only (one side)</option>
//                 <option value="both-same-side">Front & Back on same paper side</option>
//                 <option value="duplex">Duplex: Front on front side, Back on back side</option>
//               </select>
//             </div>

//             {/* Gaps */}
//             <div>
//               <label style={{ fontWeight: 600, fontSize: '.85rem' }}>Gaps (mm)</label>
//               <div style={{ display: 'flex', gap: 8 }}>
//                 <input
//                   type="number"
//                   className="search-input"
//                   value={gapRow}
//                   onChange={e => setGapRow(Number(e.target.value))}
//                   placeholder="Row gap"
//                   style={{ width: '50%' }}
//                 />
//                 <input
//                   type="number"
//                   className="search-input"
//                   value={gapCol}
//                   onChange={e => setGapCol(Number(e.target.value))}
//                   placeholder="Col gap"
//                   style={{ width: '50%' }}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Rotation (only for same-side) */}
//           {pattern === 'both-same-side' && (
//             <div style={{ marginBottom: 16 }}>
//               <label style={{ fontWeight: 600, fontSize: '.85rem' }}>
//                 Backside Rotation (degrees)
//               </label>
//               <input
//                 type="number"
//                 className="search-input"
//                 value={rotationBack}
//                 onChange={e => setRotationBack(Number(e.target.value))}
//                 style={{ width: 120, marginLeft: 8 }}
//                 min="0"
//                 max="360"
//                 step="1"
//               />
//               <span style={{ fontSize: '.8rem', color: 'var(--text-muted)', marginLeft: 8 }}>
//                 (rotate back card when placed on same side)
//               </span>
//             </div>
//           )}

//           {/* --- Profile filters and list (same as before) --- */}
//           <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
//             <select
//               className="search-input"
//               style={{ maxWidth: 130 }}
//               value={filterJob}
//               onChange={e => setFilterJob(e.target.value)}
//             >
//               <option value="">All Jobs</option>
//               {(jobOptions || []).map(j => <option key={j} value={j}>Job {j}</option>)}
//             </select>
//             <select
//               className="search-input"
//               style={{ maxWidth: 140 }}
//               value={filterClass}
//               onChange={e => setFilterClass(e.target.value)}
//             >
//               <option value="">All Classes</option>
//               {(classOptions || []).map(c => <option key={c} value={c}>{c}</option>)}
//             </select>
//             <span style={{ color: 'var(--text-muted)', fontSize: '.82rem', alignSelf: 'center' }}>
//               {selectedIds.size}/{filteredProfs.length} selected
//             </span>
//             <button
//               className="btn btn-outline btn-sm"
//               onClick={() => setSelectedIds(new Set(filteredProfs.map(p => p._id)))}
//             >
//               All
//             </button>
//             <button
//               className="btn btn-ghost btn-sm"
//               onClick={() => setSelectedIds(new Set())}
//             >
//               None
//             </button>
//           </div>

//           <div
//             style={{
//               maxHeight: 240,
//               overflowY: 'auto',
//               border: '1px solid var(--border)',
//               borderRadius: 'var(--radius-sm)',
//               marginBottom: 14,
//             }}
//           >
//             <table style={{ width: '100%' }}>
//               <thead>
//                 <tr style={{ background: 'var(--bg3)', position: 'sticky', top: 0 }}>
//                   <th style={{ width: 36, padding: '6px 10px' }}>
//                     <input
//                       type="checkbox"
//                       checked={
//                         filteredProfs.length > 0 &&
//                         filteredProfs.every(p => selectedIds.has(p._id))
//                       }
//                       onChange={() => {
//                         if (filteredProfs.every(p => selectedIds.has(p._id)))
//                           setSelectedIds(new Set());
//                         else
//                           setSelectedIds(new Set(filteredProfs.map(p => p._id)));
//                       }}
//                       style={{ accentColor: 'var(--primary)', cursor: 'pointer' }}
//                     />
//                   </th>
//                   <th style={{ textAlign: 'left', padding: '6px 8px', fontSize: '.78rem' }}>Name</th>
//                   <th style={{ textAlign: 'left', padding: '6px 8px', fontSize: '.78rem' }}>Class</th>
//                   <th style={{ textAlign: 'left', padding: '6px 8px', fontSize: '.78rem' }}>Job</th>
//                   <th style={{ textAlign: 'left', padding: '6px 8px', fontSize: '.78rem' }}>Photo</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredProfs.map(p => (
//                   <tr
//                     key={p._id}
//                     style={{
//                       borderBottom: '1px solid var(--border)',
//                       background: selectedIds.has(p._id) ? 'rgba(var(--primary-rgb),.06)' : undefined,
//                     }}
//                   >
//                     <td style={{ padding: '5px 10px' }}>
//                       <input
//                         type="checkbox"
//                         checked={selectedIds.has(p._id)}
//                         onChange={() => toggleSelect(p._id)}
//                         style={{ accentColor: 'var(--primary)', cursor: 'pointer' }}
//                       />
//                     </td>
//                     <td style={{ padding: '5px 8px', fontSize: '.82rem' }}>{p.name || '—'}</td>
//                     <td style={{ padding: '5px 8px', fontSize: '.82rem' }}>{p.class || '—'}</td>
//                     <td style={{ padding: '5px 8px', fontSize: '.78rem' }}>
//                       <span className="badge badge-blue" style={{ fontSize: '.7rem' }}>
//                         Job{p.jobNo || '—'}
//                       </span>
//                     </td>
//                     <td style={{ padding: '5px 8px' }}>
//                       {p.photoPath ? (
//                         <span style={{ fontSize: '.72rem', color: 'var(--success)' }}>✅</span>
//                       ) : (
//                         <span style={{ fontSize: '.72rem', color: 'var(--text-muted)' }}>—</span>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div style={{ fontSize: '.8rem', color: 'var(--text-muted)' }}>
//             {frontTemplateId && (
//               <span>
//                 Front: <b>{frontTemplates.find(t => t._id === frontTemplateId)?.name || '—'}</b>
//                 {backTemplateId && (
//                   <span> · Back: <b>{backTemplates.find(t => t._id === backTemplateId)?.name || '—'}</b></span>
//                 )}
//               </span>
//             )}
//           </div>
//         </div>

//         <div className="modal-footer">
//           <button className="btn btn-outline" onClick={onClose}>Cancel</button>
//           <button
//             className="btn btn-primary"
//             onClick={handleExport}
//             disabled={exporting || !frontTemplateId || !selectedIds.size}
//           >
//             {exporting
//               ? '⏳ Generating…'
//               : `Export ${selectedIds.size} Cards (${format.toUpperCase()})`}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const BASE_URL = process.env.REACT_APP_API_URL || '';

export default function CardExportModal({
  profiles,
  jobOptions,
  classOptions,
  username,
  onClose,
  api
}) {
  const [templates, setTemplates] = useState([]);
  const [filterJob, setFilterJob] = useState('');
  const [filterClass, setFilterClass] = useState('');
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [filteredProfs, setFilteredProfs] = useState(profiles || []);
  const [exporting, setExporting] = useState(false);

  // Export options
  const [format, setFormat] = useState('pdf');
  const [pattern, setPattern] = useState('front-only');
  const [paperSize, setPaperSize] = useState('A4');
  const [customWidth, setCustomWidth] = useState(210);
  const [customHeight, setCustomHeight] = useState(297);
  const [gapRow, setGapRow] = useState(2);
  const [gapCol, setGapCol] = useState(2);
  const [rotationBack, setRotationBack] = useState(180);
  const [frontTemplateId, setFrontTemplateId] = useState('');
  const [backTemplateId, setBackTemplateId] = useState('');

  const paperSizes = {
    A4: { w: 210, h: 297 },
    A5: { w: 148, h: 210 },
    '4x6': { w: 101.6, h: 152.4 },
    '8x12': { w: 203.2, h: 304.8 },
    '12x18': { w: 304.8, h: 457.2 },
    '13x19': { w: 330.2, h: 482.6 },
    custom: { w: customWidth, h: customHeight },
  };

  useEffect(() => {
    api.get('/templates')
      .then(r => {
        setTemplates(r.data);
        const front = r.data.find(t => t.cardSide === 'front');
        const back = r.data.find(t => t.cardSide === 'back');
        if (front) setFrontTemplateId(front._id);
        if (back) setBackTemplateId(back._id);
      })
      .catch(() => {});
  }, [api]);

  useEffect(() => {
    let fp = profiles || [];
    if (filterJob) fp = fp.filter(p => String(p.jobNo) === String(filterJob));
    if (filterClass) fp = fp.filter(p => p.class === filterClass);
    setFilteredProfs(fp);
    setSelectedIds(new Set(fp.map(p => p._id)));
  }, [profiles, filterJob, filterClass]);

  const toggleSelect = id => {
    setSelectedIds(prev => {
      const n = new Set(prev);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });
  };

  const getPaperDimensions = () => {
    if (paperSize === 'custom') return { w: customWidth, h: customHeight };
    const size = paperSizes[paperSize];
    return size ? { w: size.w, h: size.h } : { w: 210, h: 297 };
  };

  const handleExport = async () => {
    if (!frontTemplateId) {
      toast.error('Please select a front template');
      return;
    }
    if ((pattern === 'both-same-side' || pattern === 'duplex') && !backTemplateId) {
      toast.error('Please select a back template');
      return;
    }
    if (!selectedIds.size) {
      toast.error('Select at least one profile');
      return;
    }

    setExporting(true);
    try {
      const { w: paperWidth, h: paperHeight } = getPaperDimensions();
      const payload = {
        frontTemplateId,
        backTemplateId: pattern !== 'front-only' ? backTemplateId : undefined,
        profileIds: [...selectedIds],
        paperWidth,
        paperHeight,
        pattern,
        gapRow,
        gapCol,
        rotationBack: pattern === 'both-same-side' ? rotationBack : 0,
        format,
        dpi: 300,
      };

      const resp = await api.post('/templates/render/export', payload, {
        responseType: 'blob',
        headers: { Accept: format === 'jpeg' ? 'application/zip' : 'application/pdf' },
      });

      const contentType = resp.headers?.['content-type'] || '';
      const disposition = resp.headers?.['content-disposition'] || '';
      const filename = disposition.match(/filename="?(.+)"?/)?.[1] || `cards_${Date.now()}.${format === 'jpeg' ? 'zip' : 'pdf'}`;

      if (format === 'pdf' && (contentType.includes('text/html') || resp.headers?.['x-pdf-fallback'] === 'true')) {
        const blob = new Blob([resp.data], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        const win = window.open(url, '_blank');
        if (win) win.onload = () => win.print();
        URL.revokeObjectURL(url);
        toast('📄 Opened in browser — Ctrl+P to save as PDF', { icon: 'ℹ️', duration: 6000 });
      } else {
        const blob = new Blob([resp.data], {
          type: contentType || (format === 'jpeg' ? 'application/zip' : 'application/pdf'),
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
        toast.success(`Exported ${selectedIds.size} cards as ${format.toUpperCase()}`);
      }
    } catch (e) {
      let msg = 'Export failed';
      if (e.response?.data instanceof Blob) {
        try {
          const text = await e.response.data.text();
          msg = JSON.parse(text).message || msg;
        } catch {}
      } else if (e.message) msg = e.message;
      toast.error(msg);
    } finally {
      setExporting(false);
    }
  };

  const frontTemplates = templates.filter(t => t.cardSide === 'front');
  const backTemplates = templates.filter(t => t.cardSide === 'back');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 960, maxHeight: '92vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🖨️ Export ID Cards</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">

          {/* Template Selection */}
          <div style={{ marginBottom: 16, display: 'flex', gap: 20, flexWrap: 'wrap' }}>
            <div>
              <label style={{ fontWeight: 600, fontSize: '.85rem', display: 'block', marginBottom: 4 }}>Front Template</label>
              <select className="search-input" value={frontTemplateId} onChange={e => setFrontTemplateId(e.target.value)} style={{ minWidth: 150 }}>
                {frontTemplates.length === 0 && <option value="">No front templates</option>}
                {frontTemplates.map(t => <option key={t._id} value={t._id}>{t.name}</option>)}
              </select>
            </div>
            {(pattern === 'both-same-side' || pattern === 'duplex') && (
              <div>
                <label style={{ fontWeight: 600, fontSize: '.85rem', display: 'block', marginBottom: 4 }}>Back Template</label>
                <select className="search-input" value={backTemplateId} onChange={e => setBackTemplateId(e.target.value)} style={{ minWidth: 150 }}>
                  {backTemplates.length === 0 && <option value="">No back templates</option>}
                  {backTemplates.map(t => <option key={t._id} value={t._id}>{t.name}</option>)}
                </select>
              </div>
            )}
          </div>

          {/* Export Options Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
            <div>
              <label style={{ fontWeight: 600, fontSize: '.85rem' }}>Paper Size</label>
              <select className="search-input" value={paperSize} onChange={e => setPaperSize(e.target.value)} style={{ width: '100%' }}>
                <option value="A4">A4 (210×297 mm)</option>
                <option value="A5">A5 (148×210 mm)</option>
                <option value="4x6">4×6" (101.6×152.4 mm)</option>
                <option value="8x12">8×12" (203.2×304.8 mm)</option>
                <option value="12x18">12×18" (304.8×457.2 mm)</option>
                <option value="13x19">13×19" (330.2×482.6 mm)</option>
                <option value="custom">Custom</option>
              </select>
              {paperSize === 'custom' && (
                <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                  <input type="number" className="search-input" value={customWidth} onChange={e => setCustomWidth(Number(e.target.value))} placeholder="Width (mm)" style={{ width: '50%' }} />
                  <input type="number" className="search-input" value={customHeight} onChange={e => setCustomHeight(Number(e.target.value))} placeholder="Height (mm)" style={{ width: '50%' }} />
                </div>
              )}
            </div>

            <div>
              <label style={{ fontWeight: 600, fontSize: '.85rem' }}>Export Format</label>
              <div style={{ display: 'flex', gap: 16, marginTop: 4 }}>
                <label><input type="radio" value="pdf" checked={format === 'pdf'} onChange={() => setFormat('pdf')} /> PDF</label>
                <label><input type="radio" value="jpeg" checked={format === 'jpeg'} onChange={() => setFormat('jpeg')} /> JPEG (300 DPI)</label>
              </div>
            </div>

            <div>
              <label style={{ fontWeight: 600, fontSize: '.85rem' }}>Card Layout</label>
              <select className="search-input" value={pattern} onChange={e => setPattern(e.target.value)} style={{ width: '100%' }}>
                <option value="front-only">Front only (one side)</option>
                <option value="both-same-side">Front & Back on same paper side</option>
                <option value="duplex">Duplex: Front on front side, Back on back side</option>
              </select>
            </div>

            <div>
              <label style={{ fontWeight: 600, fontSize: '.85rem' }}>Gaps (mm)</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input type="number" className="search-input" value={gapRow} onChange={e => setGapRow(Number(e.target.value))} placeholder="Row gap" style={{ width: '50%' }} />
                <input type="number" className="search-input" value={gapCol} onChange={e => setGapCol(Number(e.target.value))} placeholder="Col gap" style={{ width: '50%' }} />
              </div>
            </div>
          </div>

          {/* Rotation (only for same-side) */}
          {pattern === 'both-same-side' && (
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontWeight: 600, fontSize: '.85rem' }}>Backside Rotation (degrees)</label>
              <input type="number" className="search-input" value={rotationBack} onChange={e => setRotationBack(Number(e.target.value))} style={{ width: 120, marginLeft: 8 }} min="0" max="360" step="1" />
              <span style={{ fontSize: '.8rem', color: 'var(--text-muted)', marginLeft: 8 }}>(rotate back card when placed on same side)</span>
            </div>
          )}

          {/* Profile filters and list (unchanged) */}
          <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
            <select className="search-input" style={{ maxWidth: 130 }} value={filterJob} onChange={e => setFilterJob(e.target.value)}>
              <option value="">All Jobs</option>
              {(jobOptions || []).map(j => <option key={j} value={j}>Job {j}</option>)}
            </select>
            <select className="search-input" style={{ maxWidth: 140 }} value={filterClass} onChange={e => setFilterClass(e.target.value)}>
              <option value="">All Classes</option>
              {(classOptions || []).map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <span style={{ color: 'var(--text-muted)', fontSize: '.82rem', alignSelf: 'center' }}>
              {selectedIds.size}/{filteredProfs.length} selected
            </span>
            <button className="btn btn-outline btn-sm" onClick={() => setSelectedIds(new Set(filteredProfs.map(p => p._id)))}>All</button>
            <button className="btn btn-ghost btn-sm" onClick={() => setSelectedIds(new Set())}>None</button>
          </div>

          <div style={{ maxHeight: 240, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', marginBottom: 14 }}>
            <table style={{ width: '100%' }}>
              <thead>
                <tr style={{ background: 'var(--bg3)', position: 'sticky', top: 0 }}>
                  <th style={{ width: 36, padding: '6px 10px' }}>
                    <input type="checkbox" checked={filteredProfs.length > 0 && filteredProfs.every(p => selectedIds.has(p._id))}
                      onChange={() => {
                        if (filteredProfs.every(p => selectedIds.has(p._id))) setSelectedIds(new Set());
                        else setSelectedIds(new Set(filteredProfs.map(p => p._id)));
                      }}
                      style={{ accentColor: 'var(--primary)', cursor: 'pointer' }} />
                  </th>
                  <th style={{ textAlign: 'left', padding: '6px 8px', fontSize: '.78rem' }}>Name</th>
                  <th style={{ textAlign: 'left', padding: '6px 8px', fontSize: '.78rem' }}>Class</th>
                  <th style={{ textAlign: 'left', padding: '6px 8px', fontSize: '.78rem' }}>Job</th>
                  <th style={{ textAlign: 'left', padding: '6px 8px', fontSize: '.78rem' }}>Photo</th>
                </tr>
              </thead>
              <tbody>
                {filteredProfs.map(p => (
                  <tr key={p._id} style={{ borderBottom: '1px solid var(--border)', background: selectedIds.has(p._id) ? 'rgba(var(--primary-rgb),.06)' : undefined }}>
                    <td style={{ padding: '5px 10px' }}>
                      <input type="checkbox" checked={selectedIds.has(p._id)} onChange={() => toggleSelect(p._id)}
                        style={{ accentColor: 'var(--primary)', cursor: 'pointer' }} />
                    </td>
                    <td style={{ padding: '5px 8px', fontSize: '.82rem' }}>{p.name || '—'}</td>
                    <td style={{ padding: '5px 8px', fontSize: '.82rem' }}>{p.class || '—'}</td>
                    <td style={{ padding: '5px 8px', fontSize: '.78rem' }}>
                      <span className="badge badge-blue" style={{ fontSize: '.7rem' }}>Job{p.jobNo || '—'}</span>
                    </td>
                    <td style={{ padding: '5px 8px' }}>
                      {p.photoPath ? <span style={{ fontSize: '.72rem', color: 'var(--success)' }}>✅</span> : <span style={{ fontSize: '.72rem', color: 'var(--text-muted)' }}>—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ fontSize: '.8rem', color: 'var(--text-muted)' }}>
            {frontTemplateId && <span>Front: <b>{frontTemplates.find(t => t._id === frontTemplateId)?.name || '—'}</b>
              {backTemplateId && <span> · Back: <b>{backTemplates.find(t => t._id === backTemplateId)?.name || '—'}</b></span>}
            </span>}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" onClick={handleExport} disabled={exporting || !frontTemplateId || !selectedIds.size}>
            {exporting ? '⏳ Generating…' : `Export ${selectedIds.size} Cards (${format.toUpperCase()})`}
          </button>
        </div>
      </div>
    </div>
  );
}